// extracted by mini-css-extract-plugin
export default {"progress":"progress--SV02w","warning":"warning--MtFEO","overdue":"overdue--PE580","icon":"icon--WqZZd","title":"title--iyIfc"};